import React, { Component } from 'react';
import { Row, Col, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import Scheduler, { DATE_FORMAT, SchedulerData } from './RosterScheduler'
import { inject, observer } from 'mobx-react';
import moment from 'moment';

//components
import { CellUnits, ViewTypes } from '../../../components/Scheduler';
import withDragDropContext from '~/hoc/withDnDContext';
import applicationRouter from '../../../hoc/applicationRouter';
import withLocalization from '../../../hoc/withLocalization';
import WeeklyShiftCodeModal from './WeeklyShiftCodeModal';
import BrokenRuleCard from './BrokenRuleCardComp';
import UrgentCallManagement from '../Schedule/UrgentCallManagement';

//elements
import Button from '~/components/CustomButton/CustomButton.jsx';
import Input from '~/elements/Input';
import LoadingSpinner from '~/elements/LoadingSpinner';

//utils
import { minutesToTimeInput } from '../../../utils/timeCalc';
import { roster_statuses } from '~/utils/normalStatuses';
import { getDatesFromDurationByWeekDay, getWeekDays, removeEmptyObjects } from '~/utils/commonMethods';
import { isoWeekdayMap } from '~/utils/constants';
import { validateModuleAccess } from '../../../library/stores/userStore';

//assets
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import { CopyWeeksNoDnD as CopyWeeks } from './CopyWeeks';
import { getCycleStartDate } from '../../../utils/rosterMethods';
import { buildShiftDataFromCycleData, mergeFCodeChangesIntoCycleData, getClientNationalHolidays, processFCodes } from '../../../utils/fCodeUtils';

const formatShiftsAccordingToWeekWise = (userRule, commonStore) => {
    const cycleData = {};
    Object.entries(userRule.shift_data).forEach(([date, { shiftId, fCodeId, standbyCodeId, isPublishedAndEdited, publishedEditedAt }]) => {
        const momentDate = moment(date);
        const week = momentDate.isoWeek();
        const day = momentDate.format('dddd').toLowerCase();
        const shiftCodeId = commonStore?.getCompanyShift(shiftId)?.id;
        if (!cycleData[week]) cycleData[week] = {};
        cycleData[week][day] = { date: moment(date).format('DD.MM.YYYY'), shiftCodeId, fCodeId: fCodeId || undefined, standbyCodeId: standbyCodeId || undefined, isPublishedAndEdited: isPublishedAndEdited || false, publishedEditedAt: publishedEditedAt || null };
    });
    return cycleData;
}

const generateNextCycleData = (currentCycleData, weeksToAdd) => {
    const nextCycleData = {};

    Object.entries(currentCycleData).forEach(([weekNum, weekData]) => {
        const currentWeekNum = parseInt(weekNum, 10);
        const nextWeekNum = currentWeekNum + weeksToAdd;
        const updatedWeekData = {};

        Object.entries(weekData).forEach(([dayKey, dayData]) => {
            if (dayData.date) {
                const currentDate = moment(dayData.date, 'DD.MM.YYYY');
                const nextDate = moment(currentDate).add(weeksToAdd, 'weeks');

                updatedWeekData[dayKey] = {
                    ...dayData,
                    date: nextDate.format('DD.MM.YYYY')
                };
            }
        });

        nextCycleData[nextWeekNum] = updatedWeekData;
    });

    return nextCycleData;
};

class CreateRosterTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            userWorkHoursRuleByDepartment: null,
            isLoading: true,
            templateName: '',
            currentUserRosterTemplate: null,
            schedulerData: null,
            showShiftCodeModal: false,
            selectedWeekData: null,
            cycleData: {},
            events: [],
            weeklyHoursTotalsAndEmploymentPercent: {},
            employmentPercentHourByDepartment: null,
            weeklyHoursTotals: {},
            exceptions: {},
            publishedRosterExceptions: {},
            exceptionReasons: {},
            cycleDetails: {},
            allowSaveShifts: false,
            isInEditMode: true,
            showisTemplateAssignedToOthersModal: false,
            isNextCycleStatusActive: false,
            isInLockInOfUnionApproval: false,
            isInLockInOfPublish: false,
            width: 0,
            showEditInputModal: false,
            isMultiUserTemplate: false,
            saveParticularUserTemplate: false,
            showCopyWeekModal: false,
            cycle_totals: {
                total_work_hours: 0,
                average_work_hours: 0,
                total_employment_percent_according_to_user_profile: 0,
                total_employment_percent_according_to_standard_control_panel_rule: 0,
                total_standby_hours: 0
            },
            workPatternAssignment: null,
            approvedF5Map: new Map(),
            f5Placements: [],
            showUrgentShiftModal: false,
            urgentCallEditing: null,
            conflictMessage: null,
        };
        this.scheduleRef = React.createRef();
        props.handleCrossClick();
    }

    componentDidMount() {
        this.loadData();
        window.addEventListener('resize', this.updateWidth);
    }

    componentDidUpdate(_, prevState) {
        if (prevState.isLoading && !this.state.isLoading) {
            this.updateWidth();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    updateWidth = () => {
        if (this.scheduleRef.current) {
            this.setState({ width: this.scheduleRef.current.offsetWidth });
        }
    };

    loadData = async () => {
        try {
            const { userStore, router, clientStore, commonStore, rosterStore, t } = this.props;
            const { userId, eventDate, event, add = false } = router.location.state;
            const { status, rosterId } = event || {};
            const dateTimeRules = commonStore.getDateTimeRules();
            this.setState({ isLoading: true })
            const user = await userStore.pullUserById(userId);

            let userWorkHoursRuleByDepartment = null, userRosterTemplate = null, startDate = '', endDate = '', isInEditMode = true, isNextCycleStatusActive = false, isInLockInOfUnionApproval = false, isInLockInOfPublish = false, employmentPercentHourByDepartment = 0, workPatternAssignment = null;
            if (status === 'expired') {
                const roster = await rosterStore.getExpiredRosterDetailsByUserId(userId, { rosterId });
                isNextCycleStatusActive = roster?.isNextCycleStatusActive;
                isInLockInOfUnionApproval = roster?.isInLockInOfUnionApproval;
                isInLockInOfPublish = roster?.isInLockInOfPublish;
                userRosterTemplate = roster?.employeeRosters || null;
                isInEditMode = false;
                startDate = roster?.employeeRosters?.cycle_start_date || '';
                endDate = roster?.employeeRosters?.cycle_end_date || '';
                userWorkHoursRuleByDepartment = userRosterTemplate ? userRosterTemplate?.Roster_Template.rules : await clientStore.getWorkHoursRuleByDepartment(user.employee_type);
            }
            else {
                userWorkHoursRuleByDepartment = await clientStore.getWorkHoursRuleByDepartment(user.employee_type);
                if (!userWorkHoursRuleByDepartment) {
                    commonStore.addNotification(('Workrule not added for this user department'), null, 'error');
                    return this.getBack()
                }
                const { cycle_week_length, rule_cycle_start_date } = userWorkHoursRuleByDepartment;
                if ((!add && moment(eventDate).isBefore(rule_cycle_start_date)) || eventDate === undefined) {
                    if (eventDate)
                        commonStore.addNotification(`${t('Department cycle has been assigned from')} ${moment(rule_cycle_start_date).format(dateTimeRules.short_date_format)}`, null, 'error');
                    startDate = getCycleStartDate(rule_cycle_start_date, cycle_week_length, moment(rule_cycle_start_date)).format(DATE_FORMAT);
                    endDate = moment(startDate).add(cycle_week_length, 'weeks').add(-1, 'day').format(DATE_FORMAT)
                }
                else {
                    startDate = getCycleStartDate(rule_cycle_start_date, cycle_week_length, moment(eventDate)).format(DATE_FORMAT);
                    endDate = moment(startDate).add(cycle_week_length, 'weeks').add(-1, 'day').format(DATE_FORMAT)
                }

                employmentPercentHourByDepartment = ((userWorkHoursRuleByDepartment.average_overtime_limit_per_week / 60) * (user.employee_percent)) / 100;
                const roster = await rosterStore.getRosterTemplateByUserId(userId, { startDate, endDate, eventDate })
                isNextCycleStatusActive = roster?.isNextCycleStatusActive;
                isInLockInOfUnionApproval = roster?.isInLockInOfUnionApproval;
                isInLockInOfPublish = roster?.isInLockInOfPublish;
                userRosterTemplate = roster?.employeeRosters || null;
                isInEditMode = userRosterTemplate ? false : true;
                workPatternAssignment = roster?.workPatternAssignment || null;

                if (!userRosterTemplate && !add) {
                    const fallback = await rosterStore.getRosterByUserIdAndDate(userId, { date: eventDate || startDate });
                    if (fallback?.employeeRosters) {
                        userRosterTemplate = fallback.employeeRosters;
                        startDate = userRosterTemplate.cycle_start_date;
                        endDate = userRosterTemplate.cycle_end_date;
                        userWorkHoursRuleByDepartment = userRosterTemplate.Roster_Template?.rules || userWorkHoursRuleByDepartment;
                        isInEditMode = false;
                        isNextCycleStatusActive = false;
                        isInLockInOfUnionApproval = false;
                        isInLockInOfPublish = false;
                    }
                }
            }

            this.setState({
                user, userWorkHoursRuleByDepartment, employmentPercentHourByDepartment,
                cycleDetails: { startDate, endDate },
                currentUserRosterTemplate: userRosterTemplate,
                templateName: userRosterTemplate?.Roster_Template?.name || '',
                isNextCycleStatusActive,
                isInLockInOfUnionApproval,
                isInLockInOfPublish,
                isInEditMode,
                workPatternAssignment: workPatternAssignment || null,
            },
                () => {
                    this.setState({ isLoading: false });
                    this.initializeCycleData(user, userRosterTemplate);
                })
        }
        catch (e) {
            console.error(e)
            this.getBack()
        }
    }

    async reloadData(schedulerData) {
        if (!schedulerData) schedulerData = this.state.schedulerData;
        const { user, events } = this.state;

        schedulerData.setEvents(events);
        schedulerData.setResources([{
            id: user.id,
            name: user.first_name + " " + user.last_name,
            employee_percent: user.employee_percent || 0,
            work_time_agreement: user.work_time_agreement || 0
        }]);

        this.setState({ schedulerData, isLoading: false });
        return schedulerData;
    }

    getWeekInitialData = () => {
        const { cycleDetails } = this.state;
        const cycleStart = moment(cycleDetails.startDate);
        const cycleEnd = moment(cycleDetails.endDate);
        let weekCursor = cycleStart.clone().startOf('isoWeek');
        const weekNumberData = {};
        while (weekCursor.isSameOrBefore(cycleEnd, 'day')) {
            const weekNumber = weekCursor.isoWeek();
            const weekData = {};
            weekNumberData[weekNumber] = weekData;
            weekCursor.add(1, 'week');
        }
        return weekNumberData;
    }

    initializeCycleData = (user, userRosterTemplate) => {
        const weekObj = this.getWeekInitialData()
        const initializedCycleData = Object.fromEntries(Object.keys(weekObj).map(week => [week, {}]));
        this.setState({ cycleData: initializedCycleData, isLoading: false }, () => {
            this.initRosterScheduler(user, userRosterTemplate);
        });
    };

    initRosterScheduler = (user, userRosterTemplate) => {
        const { cycleData } = this.state;
        const { t } = this.props;
        let rosterSchedulerData = new SchedulerData(
            moment().format('YYYY-MM-DD'),
            ViewTypes.Custom1,
            false,
            false,
            {
                startResizable: false,
                endResizable: false,
                movable: false,
                resourceName: t('Employee name'),
                nonAgendaOtherCellHeaderFormat: 'ddd | D',
                schedulerWidth: '78%',
                tableHeaderHeight: 75,
                eventItemHeight: 40,
                eventItemLineHeight: 40,
                yearCellWidth: 60,
                nonAgendaSlotMinHeight: '42px'
            },
            { getCustomDateFunc: this.getCustomDate },
        );
        rosterSchedulerData.localeMoment.locale('en');
        rosterSchedulerData.commonStore = this.props.commonStore;
        rosterSchedulerData.setResources([{ id: user.id, name: user.first_name + " " + user.last_name, employee_percent: user.employee_percent || 0, work_time_agreement: user.work_time_agreement }]);
        rosterSchedulerData.setEvents(this.state.events.filter(ev => ev.resourceId === user.id));
        this.setState({ schedulerData: rosterSchedulerData }, () => {
            const { commonStore } = this.props;
            if (userRosterTemplate) {
                let exceptions = {};
                let exceptionReasons = {};

                if (userRosterTemplate?.exceptions) {
                    Object.entries(userRosterTemplate.exceptions).forEach(([key, value]) => {
                        if (value) {
                            if (!(/_(f[1-5])_/.test(key))) {
                                exceptions[key] = value.exception;
                            }
                            if (value.reason) {
                                exceptionReasons[key] = value.reason;
                            }
                        }
                    });
                }
                const getDraftShifts = formatShiftsAccordingToWeekWise(userRosterTemplate, commonStore);
                this.setState({ cycleData: { ...this.state.cycleData, ...getDraftShifts }, exceptions, exceptionReasons }, async () => {
                    let approvedF5Map = new Map();
                    if (userRosterTemplate?.id) {
                        try {
                            const { placements } = await this.props.rosterStore.getFCodePlacements(userRosterTemplate.id);
                            placements.forEach(p => {
                                if (p.fcode === 'F5' && p.status === 'approved') {
                                    approvedF5Map.set(p.trigger_date, p.placement_date);
                                }
                            });
                        } catch (e) { /* use empty map on error */ }
                    }
                    this.setState({ approvedF5Map }, () => {
                        this.generateEventsFromCycleData(this.state.cycleData);
                    });
                });
            }
        })
    }

    goNext = async () => {
        const { rosterStore } = this.props;
        const { userWorkHoursRuleByDepartment, cycleDetails, user, currentUserRosterTemplate } = this.state
        if (currentUserRosterTemplate?.status === 'expired') return;
        const { endDate } = cycleDetails;
        const _startDate = moment(endDate).add(1, 'day').format('YYYY-MM-DD')
        const _endDate = moment(_startDate).add(userWorkHoursRuleByDepartment.cycle_week_length, 'weeks').add(-1, 'day').format('YYYY-MM-DD');
        this.setState({ isLoading: true });
        const { employeeRosters: userRosterTemplate, isNextCycleStatusActive, isInLockInOfUnionApproval, isInLockInOfPublish, workPatternAssignment: nextWorkPatternAssignment } = await rosterStore.getRosterTemplateByUserId(user.id, { startDate: _startDate, endDate: _endDate })

        this.setState({
            cycleDetails: { startDate: _startDate, endDate: _endDate },
            currentUserRosterTemplate: userRosterTemplate,
            templateName: userRosterTemplate?.Roster_Template?.name || '',
            isNextCycleStatusActive,
            isInLockInOfUnionApproval,
            isInLockInOfPublish,
            isInEditMode: userRosterTemplate ? false : true,
            workPatternAssignment: nextWorkPatternAssignment || null,
            exceptions: {}, exceptionReasons: {}, weeklyHoursTotalsAndEmploymentPercent: {}, cycle_totals: {
                total_work_hours: 0,
                average_work_hours: 0,
                total_employment_percent_according_to_user_profile: 0,
                total_employment_percent_according_to_standard_control_panel_rule: 0,
                total_standby_hours: 0
            },
        }, () => {
            this.initializeCycleData(user, userRosterTemplate);
        });
    };

    goPrev = async () => {
        const { rosterStore } = this.props;
        const { userWorkHoursRuleByDepartment, cycleDetails, user, currentUserRosterTemplate } = this.state
        if (currentUserRosterTemplate?.status === 'expired') return;
        const { startDate, endDate } = cycleDetails;
        const _startDate = moment(startDate).add(-userWorkHoursRuleByDepartment.cycle_week_length, 'weeks').format('YYYY-MM-DD')
        const _endDate = moment(endDate).add(-userWorkHoursRuleByDepartment.cycle_week_length, 'weeks').format('YYYY-MM-DD')
        if (moment(_startDate).isBefore(userWorkHoursRuleByDepartment.rule_cycle_start_date)) return;

        this.setState({ isLoading: true });
        const { employeeRosters: userRosterTemplate, isNextCycleStatusActive, isInLockInOfUnionApproval, isInLockInOfPublish, workPatternAssignment: prevWorkPatternAssignment } = await rosterStore.getRosterTemplateByUserId(user.id, { startDate: _startDate, endDate: _endDate })
        this.setState({
            cycleDetails: { startDate: _startDate, endDate: _endDate },
            currentUserRosterTemplate: userRosterTemplate,
            templateName: userRosterTemplate?.Roster_Template?.name || '',
            isNextCycleStatusActive,
            isInLockInOfUnionApproval,
            isInLockInOfPublish,
            isInEditMode: userRosterTemplate ? false : true,
            workPatternAssignment: prevWorkPatternAssignment || null,
            exceptions: {}, exceptionReasons: {}, weeklyHoursTotalsAndEmploymentPercent: {}, cycle_totals: {
                total_work_hours: 0,
                average_work_hours: 0,
                total_employment_percent_according_to_user_profile: 0,
                total_employment_percent_according_to_standard_control_panel_rule: 0,
                total_standby_hours: 0
            }
        }, () => {
            this.initializeCycleData(user, userRosterTemplate);
        });
    };

    loadCopyWeekCycleData = (cycleData) => {
        const { user } = this.state;
        const userCycleData = cycleData[user.id] || {};
        // CopyWeeks outputs dates as 'YYYY-MM-DD'; normalize all to 'DD.MM.YYYY'
        const normalizedCycleData = {};
        for (const [weekKey, weekData] of Object.entries(userCycleData)) {
            normalizedCycleData[weekKey] = {};
            for (const [dayKey, dayData] of Object.entries(weekData)) {
                normalizedCycleData[weekKey][dayKey] = {
                    ...dayData,
                    date: moment(dayData.date, ['YYYY-MM-DD', 'DD.MM.YYYY']).format('DD.MM.YYYY')
                };
            }
        }
        this.setState({ cycleData: { ...normalizedCycleData } }, () => {
            this.generateEventsFromCycleData(normalizedCycleData);
        });
    }

    handleSaveTemplate = async (type) => {
        const { events, exceptionReasons, exceptions, templateName, userWorkHoursRuleByDepartment, user, currentUserRosterTemplate, cycleDetails, cycle_totals, workPatternAssignment, cycleData } = this.state;
        const { rosterStore, commonStore, userStore, t } = this.props;
        const rosterEvents = {}
        const shiftDetails = {};
        if (!templateName) {
            return commonStore.addNotification(('Template Name is required'), null, 'error');
        }
        if (!events.length) {
            return commonStore.addNotification(('Shifts are required'), null, 'error');
        }

        // Process events to get shift data and unique shifts
        events.forEach(ele => {
            rosterEvents[ele.for_date] = { shiftId: ele.shiftId };
            if (ele.isPublishedAndEdited === true) {
                rosterEvents[ele.for_date].isPublishedAndEdited = true;
                if (ele.publishedEditedAt) {
                    rosterEvents[ele.for_date].publishedEditedAt = ele.publishedEditedAt;
                }
            }
            // Add to shiftDetails if not already present
            if (ele.title && !shiftDetails[ele.shiftId]) {
                const shiftInfo = commonStore.getCompanyShift(ele.shiftId);
                if (shiftInfo) {
                    shiftDetails[ele.shiftId] = {
                        id: shiftInfo.id,
                        shift_code: shiftInfo.short_code,
                        shift_name: shiftInfo.shift_name,
                        start_time: shiftInfo.start_time,
                        end_time: shiftInfo.end_time,
                        normal_work_day: shiftInfo.normal_work_day,
                    };
                }
            }
        })

        // Patch secondary codes (fCodeId / standbyCodeId) into shift_data from cycleData
        const addShiftDetail = (shiftId) => {
            if (!shiftId || shiftDetails[shiftId]) return;
            const shiftInfo = commonStore.getCompanyShift(shiftId);
            if (!shiftInfo) return;
            shiftDetails[shiftId] = {
                id: shiftInfo.id,
                shift_code: shiftInfo.short_code,
                shift_name: shiftInfo.shift_name,
                start_time: shiftInfo.start_time,
                end_time: shiftInfo.end_time,
                normal_work_day: shiftInfo.normal_work_day,
            };
        };
        Object.values(cycleData || {}).forEach(weekData => {
            Object.values(weekData || {}).forEach(dayData => {
                if (!dayData?.date) return;
                const date = moment(dayData.date, 'DD.MM.YYYY').format('YYYY-MM-DD');
                if (!rosterEvents[date]) return;
                if (!dayData.shiftCodeId || dayData.shiftCodeId === dayData.standbyCodeId || dayData.shiftCodeId === dayData.fCodeId)
                    delete rosterEvents[date].shiftId;
                if (dayData.fCodeId) {
                    rosterEvents[date].fCodeId = dayData.fCodeId;
                    addShiftDetail(dayData.fCodeId);
                }
                if (dayData.standbyCodeId) {
                    rosterEvents[date].standbyCodeId = dayData.standbyCodeId;
                    addShiftDetail(dayData.standbyCodeId);
                }
            });
        });

        const mergeExceptionsWithReasons = {};
        Object.entries(exceptions).forEach(([key, value]) => {
            mergeExceptionsWithReasons[key] = { exception: value, reason: exceptionReasons[key] }
        })

        const data = {
            name: templateName,
            user_id: user.id,
            cycle_start_date: moment(cycleDetails?.startDate).format('YYYY-MM-DD'),
            cycle_end_date: moment(cycleDetails?.endDate).format('YYYY-MM-DD'),
            exceptions: mergeExceptionsWithReasons,
            shift_data: rosterEvents,
            rules: { ...userWorkHoursRuleByDepartment, shiftDetails },
            status: type,
            cycle_totals: cycle_totals
        }

        try {
            const savedTemplate = !currentUserRosterTemplate ?
                await rosterStore.createRosterTemplate(data) :
                await rosterStore.updateRosterTemplate(currentUserRosterTemplate.roster_template_id, data);
            if (this.handleUrgentCallConflict(savedTemplate)) return;
            if (savedTemplate) {
                const isWorkPattern = currentUserRosterTemplate?.Roster_Template?.work_pattern_id;
                const message = isWorkPattern
                    ? `${savedTemplate.message}. ${t('This user is part of a work pattern, so this change will apply only to the current cycle.')}`
                    : savedTemplate.message;
                commonStore.addNotification(message, null, 'success');
                this.getBack();
            }
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    }

    getBack() {
        this.props.router.navigate("/admin/roster")
    }

    handleUrgentCallConflict = (savedTemplate) => {
        const { commonStore } = this.props;
        const { user } = this.state;
        if (!savedTemplate?.error || savedTemplate.errorType !== 'conflicting_urgent_calls') return false;

        const firstLockedDate = (savedTemplate.lockedDates || [])[0];
        this.setState({
            loading: false,
            showUrgentShiftModal: true,
            conflictMessage: savedTemplate.message,
            urgentCallEditing: firstLockedDate
                ? { userId: user.id, for_date: firstLockedDate, weekNumber: moment(firstLockedDate).isoWeek() }
                : { userId: user.id }
        });
        return true;
    }

    handleCloseUrgentShiftModal = () => {
        this.setState({ showUrgentShiftModal: false, urgentCallEditing: null, conflictMessage: null });
    }

    getCustomDate = (schedulerData, num, date = undefined) => {
        const { viewType } = schedulerData;
        let selectDate = schedulerData.startDate;
        let { cycleDetails } = this.state;

        if (date != undefined)
            selectDate = date;

        let startDate = num === 0 ? selectDate :
            schedulerData.localeMoment(selectDate).add(2 * num, 'days').format(DATE_FORMAT),
            endDate = schedulerData.localeMoment(startDate).add(1, 'days').format(DATE_FORMAT),
            cellUnit = CellUnits.Hour;
        if (viewType === ViewTypes.Custom1) {
            startDate = moment(cycleDetails.startDate).format(DATE_FORMAT);
            endDate = moment(cycleDetails.endDate).format(DATE_FORMAT);
            cellUnit = CellUnits.Day;
        } else if (viewType === ViewTypes.Custom2) {
            let firstDayOfMonth = schedulerData.localeMoment(selectDate).startOf('month').format(DATE_FORMAT);
            startDate = num === 0 ? firstDayOfMonth : schedulerData.localeMoment(firstDayOfMonth).add(2 * num, 'months').format(DATE_FORMAT);
            endDate = schedulerData.localeMoment(startDate).add(1, 'months').endOf('month').format(DATE_FORMAT);
            cellUnit = CellUnits.Day;
        }

        return {
            startDate,
            endDate,
            cellUnit
        };
    }

    checkIsTemplateAssignedToOthers = async () => {
        const { rosterStore } = this.props;
        const { currentUserRosterTemplate } = this.state;
        if (!currentUserRosterTemplate) return;

        const isTemplateAssignedToOthers = await rosterStore.isTemplateAssignedToOthers(currentUserRosterTemplate.roster_template_id, currentUserRosterTemplate.user_id);
        return isTemplateAssignedToOthers.isTemplateAssignedToOthers

    }

    handleEditTemplate = async () => {
        if (!validateModuleAccess('md_Roster','createAndEdit')) return;
        const { t } = this.props;
        try {
            this.setState({ isLoading: true })
            const isAssignedToMultiple = await this.checkIsTemplateAssignedToOthers()
            if (isAssignedToMultiple) {
                confirmAlert({
                    title: t('Are you sure?'),
                    message: t(`This template is assigned to other users. To make changes, a new version will be created with a different name. Do you want to continue?`),
                    buttons: [
                        {
                            label: t('Yes'),
                            onClick: () => {
                                this.setState({ isInEditMode: true, templateName: '' })
                            },
                        },
                        {
                            label: t('No'),
                            onClick: () => {
                            }
                        }
                    ],
                });
            }
            else
                this.setState({ isInEditMode: true })
            this.setState({ isLoading: false })
        } catch (err) {
            this.setState({ isLoading: false })
            console.error(err)
        }
    }

    handleEdit = async () => {
        if (!validateModuleAccess('md_Roster','createAndEdit')) return;
        const isAssignedToMultiple = await this.checkIsTemplateAssignedToOthers();
        this.setState({ isInEditMode: true, isMultiUserTemplate: isAssignedToMultiple })
    }

    handleCheckStatusAndSave = (isMultiUserTemplate) => {
        const { t } = this.props;
        const { exceptions, currentUserRosterTemplate } = this.state;
        const { allow_strict_mode } = this.props.commonStore.config?.client?.data?.basicRules?.workPlanSettings;
        if ((!currentUserRosterTemplate?.status || currentUserRosterTemplate?.status !== 'published') && allow_strict_mode && Object.keys(exceptions).length)
            return this.props.commonStore.addNotification(this.props.t('Cannot save template with exceptions in strict mode'), null, 'error');

        if (isMultiUserTemplate)
            this.setState({ showEditInputModal: true });
        else {
            if (currentUserRosterTemplate?.status === 'published') {
                confirmAlert({
                    title: t('Are you sure?'),
                    message: t(`As you are updating the published template, The changes will be affected in the live published schedule. Please confirm to continue.`),
                    buttons: [
                        {
                            label: t('Yes'),
                            onClick: () => {
                                this.handleSaveTemplate('published')
                            },
                        },
                        {
                            label: t('No'),
                            onClick: () => { }
                        }
                    ],
                });
            }
            else
                this.handleSaveTemplate('active')
        }
    }

    handleSingleSave = () => {
        this.setState({ saveParticularUserTemplate: true, templateName: '', showEditInputModal: false })
    }

    handleEntireTemplateSave = async (type) => {
        const { events, exceptionReasons, exceptions, templateName, userWorkHoursRuleByDepartment, user, currentUserRosterTemplate, cycleDetails, cycle_totals, workPatternAssignment, cycleData } = this.state;
        const { rosterStore, commonStore } = this.props;
        const rosterEvents = {}
        const shiftDetails = {};
        if (!templateName) {
            return commonStore.addNotification(('Template Name is required'), null, 'error');
        }
        if (!events.length) {
            return commonStore.addNotification(('Shifts are required'), null, 'error');
        }

        // Process events to get shift data and unique shifts
        events.forEach(ele => {
            rosterEvents[ele.for_date] = { shiftId: ele.shiftId };
            if (ele.isPublishedAndEdited === true) {
                rosterEvents[ele.for_date].isPublishedAndEdited = true;
                if (ele.publishedEditedAt) {
                    rosterEvents[ele.for_date].publishedEditedAt = ele.publishedEditedAt;
                }
            }
            // Add to shiftDetails if not already present
            if (ele.title && !shiftDetails[ele.shiftId]) {
                const shiftInfo = commonStore.getCompanyShift(ele.shiftId);
                if (shiftInfo) {
                    shiftDetails[ele.shiftId] = {
                        id: shiftInfo.id,
                        shift_code: shiftInfo.short_code,
                        shift_name: shiftInfo.shift_name,
                        start_time: shiftInfo.start_time,
                        end_time: shiftInfo.end_time,
                        normal_work_day: shiftInfo.normal_work_day,
                    };
                }
            }
        })

        // Patch secondary codes (fCodeId / standbyCodeId) into shift_data from cycleData
        const addShiftDetail = (shiftId) => {
            if (!shiftId || shiftDetails[shiftId]) return;
            const shiftInfo = commonStore.getCompanyShift(shiftId);
            if (!shiftInfo) return;
            shiftDetails[shiftId] = {
                id: shiftInfo.id,
                shift_code: shiftInfo.short_code,
                shift_name: shiftInfo.shift_name,
                start_time: shiftInfo.start_time,
                end_time: shiftInfo.end_time,
                normal_work_day: shiftInfo.normal_work_day,
            };
        };
        Object.values(cycleData || {}).forEach(weekData => {
            Object.values(weekData || {}).forEach(dayData => {
                if (!dayData?.date) return;
                const date = moment(dayData.date, 'DD.MM.YYYY').format('YYYY-MM-DD');
                if (!rosterEvents[date]) return;
                if (!dayData.shiftCodeId || dayData.shiftCodeId === dayData.standbyCodeId || dayData.shiftCodeId === dayData.fCodeId)
                    delete rosterEvents[date].shiftId;
                if (dayData.fCodeId) {
                    rosterEvents[date].fCodeId = dayData.fCodeId;
                    addShiftDetail(dayData.fCodeId);
                }
                if (dayData.standbyCodeId) {
                    rosterEvents[date].standbyCodeId = dayData.standbyCodeId;
                    addShiftDetail(dayData.standbyCodeId);
                }
            });
        });

        const mergeExceptionsWithReasons = {};
        Object.entries(exceptions).forEach(([key, value]) => {
            mergeExceptionsWithReasons[key] = { exception: value, reason: exceptionReasons[key] }
        })

        const data = {
            name: templateName,
            cycle_start_date: moment(cycleDetails?.startDate).format('YYYY-MM-DD'),
            cycle_end_date: moment(cycleDetails?.endDate).format('YYYY-MM-DD'),
            exceptions: mergeExceptionsWithReasons,
            shift_data: rosterEvents,
            rules: { ...userWorkHoursRuleByDepartment, shiftDetails },
            status: type,
            cycle_totals: cycle_totals
        }

        try {
            const savedTemplate = await rosterStore.updateRosterAndEmployeeTemplate(currentUserRosterTemplate.roster_template_id, data);
            if (this.handleUrgentCallConflict(savedTemplate)) return;
            if (savedTemplate) {
                commonStore.addNotification((savedTemplate.message), null, 'success');
                this.getBack();
            }
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    }

    handleShowShiftCodeModal = (weekData) => {
        if (!this.state.isInEditMode && this.state.currentUserRosterTemplate && this.state.currentUserRosterTemplate?.status !== 'draft') return;
        this.setState({ showShiftCodeModal: true, selectedWeekData: { ...weekData } });
    }

    handleHideShiftCodeModal = () => {
        this.setState({ showShiftCodeModal: false, allowSaveShifts: false, isLoading: false })
    }

    updateCycleData = (weekNumber, updatedWeekData) => {
        const { currentUserRosterTemplate, cycleDetails } = this.state;
        const isRosterPublished = currentUserRosterTemplate?.status === 'published';

        this.setState(prevState => {
            const prevCycleData = prevState.cycleData;
            const currentWeekData = prevCycleData[weekNumber] || {};
            const prevExceptions = prevState.publishedRosterExceptions;
            const exceptions = { ...prevExceptions };
            // Step 1: Merge updated week into cycle data
            const cycleData = { ...prevCycleData, [weekNumber]: updatedWeekData };

            // Step 2: Identify days that were fixed and now are unfixed (including days removed from updatedWeekData)
            const unfixedDays = [
                ...Object.keys(updatedWeekData).filter(dayKey =>
                    currentWeekData[dayKey]?.fixed && !updatedWeekData[dayKey]?.fixed
                ),
                ...Object.keys(currentWeekData).filter(dayKey =>
                    currentWeekData[dayKey]?.fixed && !(dayKey in updatedWeekData)
                )
            ];

            // Step 3: Delete unfixed days across all weeks
            if (unfixedDays.length > 0) {
                for (const weekKey in cycleData) {
                    const weekData = { ...cycleData[weekKey] };
                    let changed = false;

                    for (const dayKey of unfixedDays) {
                        if (weekData[dayKey]) {
                            delete weekData[dayKey];
                            changed = true;
                        }
                    }

                    if (changed) {
                        cycleData[weekKey] = weekData;
                    }
                }
            }

            // Step 4: Collect fixed shifts from updatedWeekData only
            const fixedShifts = {};
            for (const [dayKey, dayData] of Object.entries(updatedWeekData)) {
                if (dayData.fixed && dayData.shiftCodeId) {
                    fixedShifts[dayKey] = dayData.shiftCodeId;
                }
            }

            // Step 5: Apply fixed shifts to all weeks using dynamic date computation
            const cycleStartYear = moment(cycleDetails.startDate).isoWeekYear();
            const cycleEndYear = moment(cycleDetails.endDate).isoWeekYear();
            const hasFixedShifts = Object.keys(fixedShifts).length > 0;
            for (const [weekKey, weekData] of Object.entries(cycleData)) {
                if (!hasFixedShifts) { cycleData[weekKey] = { ...weekData }; continue; }
                const updatedWeek = { ...weekData };
                let weekStart = moment().isoWeekYear(cycleStartYear).isoWeek(parseInt(weekKey)).startOf('isoWeek');
                if (cycleEndYear !== cycleStartYear && !weekStart.isBetween(cycleDetails.startDate, cycleDetails.endDate, null, '[]')) {
                    weekStart = moment().isoWeekYear(cycleEndYear).isoWeek(parseInt(weekKey)).startOf('isoWeek');
                }
                const weekEnd = weekStart.clone().endOf('isoWeek');

                for (const [dayKey, shiftCodeId] of Object.entries(fixedShifts)) {
                    const dateDetails = getDatesFromDurationByWeekDay(weekStart, weekEnd, dayKey, isoWeekdayMap);
                    dateDetails.forEach(ele => {
                        if (moment(ele).isBetween(cycleDetails.startDate, cycleDetails.endDate, null, '[]') && (!updatedWeek[dayKey] || !updatedWeek[dayKey]?.fixed)) {
                            updatedWeek[dayKey] = { fixed: false, date: moment(ele).format('DD.MM.YYYY'), shiftCodeId };
                        }
                    });
                }
                cycleData[weekKey] = updatedWeek;
            }

            // Add isPublishedAndEdited flag
            Object.entries(updatedWeekData).forEach(([dayKey, dayData]) => {
                const prevDayData = currentWeekData[dayKey] || {};
                const isFutureDate = moment(dayData.date, 'DD.MM.YYYY').isAfter(moment(), 'day');

                // Only proceed if the roster is published and the date is in the future
                if (isRosterPublished && isFutureDate) {
                    const shiftChanged = prevDayData.shiftCodeId ? dayData.shiftCodeId !== prevDayData.shiftCodeId : false;
                    const fixedChanged = dayData.fixed !== prevDayData.fixed;

                    if (shiftChanged) {
                        const key = `${moment(dayData.date, 'DD.MM.YYYY').format('YYYY-MM-DD')}_published_shift_changed`;
                        const changedOn = moment().format('MMMM D, YYYY HH:mm');
                        exceptions[key] = `${'Published roster shift changed in week'} ${moment(dayData.date, 'DD.MM.YYYY').format('MMMM D')} on ${changedOn}`;
                    }

                    // If there's a change, set isPublishedAndEdited to true
                    if (shiftChanged || fixedChanged) {
                        cycleData[weekNumber][dayKey] = { ...dayData, isPublishedAndEdited: true, publishedEditedAt: moment().format('MMMM D, YYYY HH:mm') };
                    } else if (prevDayData.isPublishedAndEdited) {
                        // Preserve existing isPublishedAndEdited flag and original edit timestamp if no changes
                        cycleData[weekNumber][dayKey] = { ...dayData, isPublishedAndEdited: true, publishedEditedAt: prevDayData.publishedEditedAt || null };
                    }
                }
            });

            return { cycleData, publishedRosterExceptions: exceptions };
        });
    };

    generateEventsFromCycleData = (cycleData, resourceId = this.props.router.location.state.userId) => {
        const { commonStore, t } = this.props;
        const { userWorkHoursRuleByDepartment, user, cycleDetails } = this.state;

        // Build F-code map from company shifts (F1/F2 auto-place; F3/F4/F5 validate)
        const fCodeMap = {};
        const fCodeIds = new Set();
        commonStore.companyShiftMap && commonStore.companyShiftMap.forEach((shift, id) => {
            if (shift.shift_type === 'freeShift') {
                fCodeIds.add(id);
                if (shift.short_code) fCodeMap[shift.short_code] = id;
            }
        });

        // Get National holidays in this cycle for F3/F4/F5 checks
        const cycleStart = moment(cycleDetails.startDate).format('YYYY-MM-DD');
        const cycleEnd = moment(cycleDetails.endDate).format('YYYY-MM-DD');
        const holidays = getClientNationalHolidays(commonStore.config && commonStore.config.clientHolidays, cycleStart, cycleEnd);

        // Run all F-code phases (auto-place F1/F2/F5, validate F3/F4, validate F1)
        const rawShiftData = buildShiftDataFromCycleData(cycleData);
        const { shiftData: processedShiftData, violations: fCodeViolations, f5Placements } = processFCodes(
            rawShiftData, cycleStart, cycleEnd, fCodeMap, fCodeIds, holidays, t, this.state.approvedF5Map
        );

        // Merge F1/F2 placements and orphaned-F3 removals back into cycleData
        const updatedCycleData = mergeFCodeChangesIntoCycleData(cycleData, rawShiftData, processedShiftData, fCodeIds);

        const newEvents = [], weekTotalObj = {}, exceptions = { ...this.state.publishedRosterExceptions };

        // Populate F-code violations into exceptions
        fCodeViolations.forEach(v => { exceptions[v.key] = v.exception; });
        const decimalPoint = this.props.commonStore?.config?.client?.data?.dateTimeRules?.currency_decimal_places
            ? this.props.commonStore.config.client.data.dateTimeRules.currency_decimal_places : 2;

        const calculatedEmployementHours = (user.employee_percent * user.work_time_agreement) / 100
        const totalLimitAccordingToCycleLength = calculatedEmployementHours * userWorkHoursRuleByDepartment.cycle_week_length

        let totalCycleHoursInMins = 0, totalStandbyHoursInMins = 0;
        Object.entries(updatedCycleData).forEach(([weekNumber, weekData]) => {
            let weekHours = 0;

            Object.entries(weekData).forEach(([dayKey, dayData]) => {
                const { shiftCodeId, date, isPublishedAndEdited, publishedEditedAt, fCodeId, standbyCodeId } = dayData;
                const shiftInfo = commonStore.getCompanyShift(shiftCodeId || fCodeId || standbyCodeId);
                if (!shiftInfo || !date) return;
                const freeCodeShift = fCodeId && shiftInfo.id !== fCodeId ? commonStore.getCompanyShift(fCodeId) : null;
                const standbyCodeShift = standbyCodeId && shiftInfo.id !== standbyCodeId ? commonStore.getCompanyShift(standbyCodeId) : null;
                if (shiftInfo) {
                    const eventId = `${resourceId}-${weekNumber}-${dayKey}`;
                    const formattedDate = moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
                    const start = `${formattedDate} ${minutesToTimeInput(shiftInfo.start_time, false)}:00`;
                    const end = `${formattedDate} ${minutesToTimeInput(shiftInfo.end_time, false)}:00`;

                    const event = {
                        id: eventId,
                        start,
                        end,
                        startTime: shiftInfo.start_time,
                        endTime: shiftInfo.end_time,
                        resourceId,
                        title: shiftInfo.short_code,
                        for_date: formattedDate,
                        shiftId: shiftInfo.id,
                        isPublishedAndEdited: isPublishedAndEdited ? true : false,
                        publishedEditedAt: publishedEditedAt || null,
                        bgColor: isPublishedAndEdited ? '#ffc4b5' : '#00000000',
                        shiftType: shiftInfo.shift_type,
                        additionalFCode: freeCodeShift?.short_code || null,
                        additionalStandbyCode: standbyCodeShift?.short_code || null
                    };
                    newEvents.push(event);

                    if (shiftInfo.shift_type === 'freeShift') return;

                    weekHours += freeCodeShift ? 0 : standbyCodeShift ? (Math.round(standbyCodeShift?.normal_work_day / standbyCodeShift?.factor)) + shiftInfo.normal_work_day : shiftInfo.id === standbyCodeId ? (Math.round(shiftInfo?.normal_work_day / shiftInfo?.factor)) : shiftInfo.normal_work_day;
                    totalCycleHoursInMins += freeCodeShift ? 0 : standbyCodeShift ? (Math.round(standbyCodeShift?.normal_work_day / standbyCodeShift?.factor)) + shiftInfo.normal_work_day : shiftInfo.id === standbyCodeId ? (Math.round(shiftInfo?.normal_work_day / shiftInfo?.factor)) : shiftInfo.normal_work_day;
                    totalStandbyHoursInMins += standbyCodeShift ? (Math.round(standbyCodeShift?.normal_work_day / standbyCodeShift?.factor)) : shiftInfo.id === standbyCodeId ? (Math.round(shiftInfo?.normal_work_day / shiftInfo?.factor)) : 0

                    if (shiftInfo.shift_type === 'standbyShift') return;

                    // Re-generate published_shift_changed exceptions for previously-edited published shifts
                    if (isPublishedAndEdited && moment(date, 'DD.MM.YYYY').isAfter(moment(), 'day')) {
                        const key = `${formattedDate}_published_shift_changed`;
                        const editedAtText = publishedEditedAt ? ` on ${publishedEditedAt}` : '';
                        exceptions[key] = `${'Published roster shift changed in week'} ${moment(date, 'DD.MM.YYYY').format('MMMM D')}${editedAtText}`;
                    }

                    // Max hours in a day rule
                    if (shiftInfo.normal_work_day > userWorkHoursRuleByDepartment?.max_hours_limit_in_a_day) {
                        const key = `week_${weekNumber}_date_${formattedDate}_max_hours_limit_in_a_day`;
                        exceptions[key] = `${t('Maximum daily work limit of')} ${userWorkHoursRuleByDepartment?.max_hours_limit_in_a_day / 60} ${t('hours was exceeded on')} ${moment(formattedDate).format('MMMM D')} (${'worked'} ${(shiftInfo.normal_work_day / 60).toFixed(1)} ${t('hours')})`;
                    }
                }
            });

            weekTotalObj[weekNumber] = {
                weekHours,
                weekEmpPercent: this.state.employmentPercentHourByDepartment
                    ? Math.round((weekHours / (this.state.employmentPercentHourByDepartment * 60)) * 100)
                    : 0
            };

        });

        // Weekly max hours for the Department rule
        for (const [week, weekDetail] of Object.entries(weekTotalObj)) {
            // Government rule for working more than 50 hours
            if (weekDetail?.weekHours > userWorkHoursRuleByDepartment.mandatory_overtime_limit_per_week) {
                const key = `week_${week}_mandatory_overtime_limit_per_week`;
                exceptions[key] = `${t('Total scheduled hours exceed the')} ${userWorkHoursRuleByDepartment?.mandatory_overtime_limit_per_week / 60}${t('-hour weekly maximum')} (${(weekDetail?.weekHours / 60).toFixed(1)} ${t('hours')})`;
            }
        }

        if (totalCycleHoursInMins / 60 > totalLimitAccordingToCycleLength) {
            const key = `cycle_work_hours_limit_exceed`;
            exceptions[key] = `${t('Total cycle work hours limit exceed of')} ${totalLimitAccordingToCycleLength} ${t('hours')}`;
        }

        // Rest between shifts rule 
        const sortedEvents = [...newEvents].filter(event => event.shiftType !== 'freeShift').sort((a, b) => new Date(a.start) - new Date(b.start));

        for (let i = 1; i < sortedEvents.length; i++) {
            const prevEnd = moment(sortedEvents[i - 1].end);
            const currStart = moment(sortedEvents[i].start);
            const rest = currStart.diff(prevEnd, 'hours', true) * 60;

            if (rest < userWorkHoursRuleByDepartment.rest_between_shifts) {
                const key = `week_${currStart.isoWeek()}_date_${currStart.format('YYYY-MM-DD')}_rest_between_shifts`;
                exceptions[key] = `${t('Required')} ${userWorkHoursRuleByDepartment.rest_between_shifts / 60}${t('-hour rest between shifts was not upheld between')} ${moment(sortedEvents[i - 1].start).format('MMMM D')} ${t('and')} ${moment(sortedEvents[i].start).format('MMMM D')} (${t('only')} ${(rest / 60).toFixed(1)} ${t('hours')}))`;
            }
        }

        const eventsByWeek = {};

        // Group events by week number
        sortedEvents.forEach(event => {
            const weekNum = moment(event.start).isoWeek();
            if (!eventsByWeek[weekNum]) eventsByWeek[weekNum] = [];
            eventsByWeek[weekNum].push(event);
        });

        // Rest of consecutive break in a week rule
        for (const [weekNum, weekEvents] of Object.entries(eventsByWeek)) {
            if (!weekEvents.length) continue;

            const sortedWeekEvents = weekEvents.sort((a, b) => new Date(a.start) - new Date(b.start));
            const requiredRestInMinutes = userWorkHoursRuleByDepartment.rest_between_week;
            let hasSufficientRest = false;

            // Check rest from start of week to first shift
            const firstShiftStart = moment(sortedWeekEvents[0].start);
            const startOfWeek = moment(firstShiftStart).startOf('isoWeek');
            const restBeforeFirstShift = firstShiftStart.diff(startOfWeek, 'minutes', true);
            if (restBeforeFirstShift >= requiredRestInMinutes) {
                hasSufficientRest = true;
            }

            // Check rest between shifts
            for (let i = 1; i < sortedWeekEvents.length; i++) {
                const prevEnd = moment(sortedWeekEvents[i - 1].end);
                const currStart = moment(sortedWeekEvents[i].start);
                const restInMinutes = currStart.diff(prevEnd, 'minutes', true);

                if (restInMinutes >= requiredRestInMinutes) {
                    hasSufficientRest = true;
                    break;
                }
            }

            // Check rest from last shift to end of week
            const lastShiftEnd = moment(sortedWeekEvents[sortedWeekEvents.length - 1].end);
            const endOfWeek = moment(lastShiftEnd).endOf('isoWeek');
            const restAfterLastShift = endOfWeek.diff(lastShiftEnd, 'minutes', true);
            if (restAfterLastShift >= requiredRestInMinutes) {
                hasSufficientRest = true;
            }

            if (!hasSufficientRest) {
                const key = `week_${weekNum}_insufficient_rest_between_week`;
                exceptions[key] = `${t('Required')} ${requiredRestInMinutes / 60}${t('-hour rest between week')} ${weekNum} ${t('was not met')} (${t('no rest period of at least')} ${(requiredRestInMinutes / 60).toFixed(1)} ${t('hours was found')})`;
            }
        }

        // Consecutive weekend work rule (0 = Sunday, 6 = Saturday)
        const weekendEvents = { 0: [], 6: [] };

        for (const e of sortedEvents) {
            const day = moment(e.start).day();
            if (day === 0 || day === 6)
                weekendEvents[day].push(moment(e.start).startOf('day'));
        }

        const checkConsecutive = (dates, dayName, maxAllowed) => {
            if (dates.length === 0) return;
            dates.sort((a, b) => a.diff(b));
            let consecutiveCount = 1;
            for (let i = 1; i < dates.length; i++) {
                const diffWeeks = dates[i].diff(dates[i - 1], 'weeks');
                if (diffWeeks === 1) {
                    consecutiveCount++;
                    if (consecutiveCount > maxAllowed) {
                        const key = `week_${dates[i].isoWeek()}_max_consecutive_working_${dayName.toLowerCase()}`;
                        exceptions[key] = `${t('Employee is scheduled to work more than')} ${maxAllowed} ${t(`consecutive ${dayName}s`)} — ${dates[i].format('MMMM D')}`;
                    }
                } else {
                    consecutiveCount = 1;
                }
            }
        };

        // Apply the rule for both weekend days
        checkConsecutive(weekendEvents[0], 'Sunday', userWorkHoursRuleByDepartment.max_consecutive_working_sunday);
        checkConsecutive(weekendEvents[6], 'Saturday', userWorkHoursRuleByDepartment.max_consecutive_working_saturday);

        const totalCycleHours = totalCycleHoursInMins / 60;
        const cycleAverageHours = totalCycleHours / userWorkHoursRuleByDepartment.cycle_week_length;
        const totalStandbyHours = totalStandbyHoursInMins / 60;
        this.setState({
            events: newEvents,
            cycleData: updatedCycleData,
            weeklyHoursTotalsAndEmploymentPercent: weekTotalObj,
            exceptions,
            isLoading: true,
            showShiftCodeModal: false,
            f5Placements: f5Placements || [],
            cycle_totals: {
                total_work_hours: totalCycleHours.toFixed(decimalPoint),
                average_work_hours: (totalCycleHours / userWorkHoursRuleByDepartment.cycle_week_length).toFixed(decimalPoint),
                total_employment_percent_according_to_user_profile: ((cycleAverageHours / calculatedEmployementHours) * 100).toFixed(decimalPoint),
                total_employment_percent_according_to_standard_control_panel_rule: ((cycleAverageHours / (userWorkHoursRuleByDepartment.average_overtime_limit_per_week / 60)) * 100).toFixed(decimalPoint),
                total_standby_hours: totalStandbyHours.toFixed(decimalPoint)
            }
        }, () => {
            this.reloadData();
        });
    };

    handleOnCellClick = (startDate) => {
        if (!this.state.isInEditMode && this.state.currentUserRosterTemplate && this.state.currentUserRosterTemplate?.status !== 'draft') return;

        const date = moment(startDate);
        const weekNumber = date.isoWeek();
        let weekStart = date.clone().startOf('isoWeek').format('YYYY-MM-DD');
        let weekEnd = date.clone().endOf('isoWeek').format('YYYY-MM-DD');
        const { cycleDetails } = this.state;

        const cycleStart = moment(cycleDetails.startDate);
        const cycleEnd = moment(cycleDetails.endDate);

        if (!moment(weekStart).isBetween(cycleStart, cycleEnd, "date", '[]'))
            weekStart = cycleStart.format('YYYY-MM-DD');

        if (!moment(weekEnd).isBetween(cycleStart, cycleEnd, "date", '[]'))
            weekEnd = cycleEnd.format('YYYY-MM-DD');

        const weekData = {
            week: weekNumber,
            start: weekStart,
            end: weekEnd,
            days: getWeekDays(weekStart, weekEnd, 'DD.MM.YYYY')
        };
        this.handleShowShiftCodeModal(weekData);
    }

    updateSelectedWeekData = (weekData) => {
        this.setState({ selectedWeekData: weekData });
    }

    handleEndPatternAndContinue = async (event) => {
        const { rosterStore, commonStore, t } = this.props;
        const { workPatternAssignment, cycleDetails } = this.state;
        try {
            const dayBeforeCycle = moment(cycleDetails.startDate).subtract(1, 'day');
            const assignmentStart = workPatternAssignment.start_date ? moment(workPatternAssignment.start_date) : dayBeforeCycle;
            const endDate = moment.max(dayBeforeCycle, assignmentStart).format('YYYY-MM-DD');
            const response = await rosterStore.updateAssignmentEndDate(workPatternAssignment.id, { end_date: endDate });
            commonStore.addNotification(response.message || t('Assignment end date updated successfully.'), null, 'success');
            this.setState({ workPatternAssignment: null }, () => {
                this.handleOnCellClick(event);
            });
        } catch (err) {
            commonStore.addNotification((err && err.message) || t('Failed to end pattern'), null, 'error');
        }
    }

    handleConfirmSwitchToEditMode = (event) => {
        if (!validateModuleAccess('md_Roster','createAndEdit')) return;
        const { t, userStore } = this.props
        const { isInEditMode, workPatternAssignment, currentUserRosterTemplate } = this.state;
        if (currentUserRosterTemplate?.status === 'expired') return;
        const isMember = userStore && userStore.currentUser && userStore.currentUser.user_type === 'member';
        if (isMember && currentUserRosterTemplate?.status === 'published') return;

        const isAuto = currentUserRosterTemplate?.Roster_Template?.automation;

        const message = isAuto
            ? t('This employee is already part of an auto-published template. Please end it before creating a new roster.')
            : t('This employee already has an active work pattern. Please end it before creating a new roster.');


        if (workPatternAssignment && !currentUserRosterTemplate) {
            confirmAlert({
                title: `${t('Work Pattern')} ${t('Already')} ${t('Assigned')}`,
                message,
                buttons: [
                    {
                        label: `${t('End')} ${t('Existing')} ${t('Assignments')}`,
                        onClick: () => this.handleEndPatternAndContinue(event),
                    },
                    {
                        label: t('Cancel'),
                        onClick: () => { }
                    }
                ],
            });
            return;
        }

        if (isInEditMode)
            this.handleOnCellClick(event)
        else {
            confirmAlert({
                title: t('Are you sure?'),
                message: t(`Current Mode is not editable, Do you want to edit these shifts?`),
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: () => {
                            this.setState({ isInEditMode: true }, () => this.handleOnCellClick(event))
                        },
                    },
                    {
                        label: t('No'),
                        onClick: () => { }
                    }
                ],
            });
        }
    }

    newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
        this.handleConfirmSwitchToEditMode(start);
    }

    eventClicked = (schedulerData, event) => {
        this.handleConfirmSwitchToEditMode(event.start);
    };

    saveExceptionReason = (key, reason) => {
        this.setState(prevState => ({
            exceptionReasons: {
                ...prevState.exceptionReasons,
                [key]: reason
            }
        }));
    };

    handleCopyToNextCycle = async () => {
        const { commonStore, t } = this.props;
        const { userWorkHoursRuleByDepartment, cycleDetails, user, cycleData } = this.state;

        try {
            // Calculate next cycle dates
            const nextStartDate = moment(cycleDetails.endDate).add(1, 'day').format('YYYY-MM-DD');
            const nextEndDate = moment(nextStartDate).add(userWorkHoursRuleByDepartment.cycle_week_length, 'weeks').add(-1, 'day').format('YYYY-MM-DD');

            const nextCycleData = generateNextCycleData(cycleData, userWorkHoursRuleByDepartment.cycle_week_length);

            if (nextCycleData) {
                commonStore.addNotification(t('Shifts copied to next cycle'), null, 'success');

                // Update UI to show the new cycle
                this.setState({
                    cycleDetails: {
                        startDate: nextStartDate,
                        endDate: nextEndDate
                    },
                    currentUserRosterTemplate: null,
                    templateName: '',
                    cycleData: nextCycleData,
                    exceptions: {}
                }, () => {
                    this.initRosterScheduler(user, null);
                    this.generateEventsFromCycleData(nextCycleData, user.id)
                });
            }
        } catch (error) {
            console.error('Error copying to next cycle:', error);
            commonStore.addNotification('Failed to copy shifts to next cycle', null, 'error');
        }
    }

    customEventItemTemplate = (_, eventItem, bgColor) => {
        return (
            <div className="fw-600 text-black text-center" style={{ marginX: 'auto', marginTop: '9px', backgroundColor: bgColor ? bgColor : '#00000000' }}>
                <div className='fs12'>{eventItem.title}</div>
                {eventItem.additionalFCode && <div className='fs12'>({eventItem.additionalFCode})</div>}
                {eventItem.additionalStandbyCode && <div className='fs12 text-nowrap text-overflow' style={{ width: '80px' }}>({eventItem.additionalStandbyCode})</div>}
            </div>
        );
    };

    handleToggleAutomation = async () => {
        const { rosterStore, commonStore, t } = this.props;
        const { workPatternAssignment } = this.state;
        if (!workPatternAssignment) return;
        try {
            const res = await rosterStore.togglePatternAutomation(workPatternAssignment.id, {});
            commonStore.addNotification((res && res.message) || t('Updated'), null, 'success');
            this.setState({ workPatternAssignment: Object.assign({}, workPatternAssignment, { status: res && res.status }) });
        } catch (err) {
            commonStore.addNotification((err && err.message) || t('Failed to update'), null, 'error');
        }
    }

    render() {
        const { commonStore, onSelectDate, t, userStore } = this.props;
        const { isLoading, showShiftCodeModal, selectedWeekData, user, userWorkHoursRuleByDepartment, currentUserRosterTemplate, isInLockInOfUnionApproval, isInLockInOfPublish,
            weeklyHoursTotalsAndEmploymentPercent, exceptions, exceptionReasons, cycleDetails, isInEditMode, width, isMultiUserTemplate, workPatternAssignment,
            showUrgentShiftModal, urgentCallEditing, conflictMessage } = this.state;
        const { status = null } = currentUserRosterTemplate || {};
        const dateTimeRules = commonStore.getDateTimeRules();

        const { lockInPeriodForUnionApproval, lockInPeriodForPublish } = commonStore.config?.client?.data.basicRules?.workPlanSettings;

        if (isLoading) return <LoadingSpinner />;

        const _startDate = moment(cycleDetails.startDate).add(-userWorkHoursRuleByDepartment?.cycle_week_length, 'weeks').format('YYYY-MM-DD')
        const isDateSameOrBeforeCycleStartDate = moment(_startDate).isBefore(userWorkHoursRuleByDepartment.rule_cycle_start_date);
        const isExpired = (currentUserRosterTemplate?.status === 'expired');
        const canCreateAndEdit = validateModuleAccess('md_Roster','createAndEdit');
        const isMember = userStore && userStore.currentUser && userStore.currentUser.user_type === 'member';

        return (
            <div ref={this.scheduleRef}>
                <div className='d-flex justify-content-between align-items-center'>
                    <span className='fw-600 custom-customer-header'>{`${t('Create')} ${t('Roster')}`}</span>
                    <div className='d-flex align-items-center gap-2'>
                        <div className="d-flex gap-2 align-items-center">
                            {currentUserRosterTemplate?.Roster_Template?.work_pattern_id && (
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip id="wp-icon-tooltip">
                                        {currentUserRosterTemplate?.Roster_Template?.automation
                                            ? t('This template is part of an automatic work pattern')
                                            : t('This template is part of a manual work pattern')}
                                    </Tooltip>}
                                >
                                    <span
                                        className="badge d-inline-flex align-items-center gap-1"
                                        style={{ backgroundColor: currentUserRosterTemplate?.Roster_Template?.automation ? '#f0fce8' : '#e8f0fe', color: currentUserRosterTemplate?.Roster_Template?.automation ? '#22863a' : '#2550AC', fontSize: '12px', padding: '6px 10px', cursor: 'pointer' }}
                                    >
                                        <i className={`fas ${currentUserRosterTemplate?.Roster_Template?.automation ? 'fa-cog' : 'fa-link'}`} />
                                        {currentUserRosterTemplate?.Roster_Template?.automation ? `${t('Automatic')} ${t('Work Pattern')}` : `${t('Manual')} ${t('Work Pattern')}`}
                                    </span>
                                </OverlayTrigger>
                            )}
                        </div>
                        {currentUserRosterTemplate && <span className={`status-block w-20 status-${currentUserRosterTemplate?.status}`}>{t(roster_statuses[currentUserRosterTemplate.status])}</span>}
                    </div>
                </div>

                {isInLockInOfUnionApproval && status !== 'published' &&
                    <div><i className='text-danger'>{t('As the lock-in Period Rule set in the control panel for union approval you can not create/update the roster template for these dates. There must be atleast')} {lockInPeriodForUnionApproval} {t('days gap to create/update the roster template')}.</i></div>
                }
                {!isInLockInOfUnionApproval && isInLockInOfPublish &&
                    <div className='mt-2'><i className='text-danger'>{t('As the lock-in Period Rule set in the control panel for publish roster you can not create the roster template for these dates.')} {t('There must be at least')} {lockInPeriodForPublish} {t('days gap to create the roster template')}.</i></div>
                }
                {(moment(cycleDetails?.startDate).isBefore(moment()) || moment(cycleDetails?.startDate).isBefore(moment().add(14, 'days'))) &&
                    <div className='mt-2'><i className='text-danger'>{t('The roster plan must be ready and available at least 14 days before it takes effect')}.</i></div>
                }
                {!currentUserRosterTemplate?.id &&
                    <div className='mt-2'><i className='text-danger'>{t('Note')}- {t('Creating templates individually will revoke the ability to edit them in the Quick Planner.')}</i></div>
                }
                <Row className='mt-2 d-flex justify-content-between align-items-end'>
                    <Col md={8}>
                        <Row>
                            <Col md={4}>
                                <label>{t('Roster Name')}</label>
                                <Input
                                    type='text' value={this.state.templateName}
                                    onChange={e => this.setState({ 'templateName': e.target.value })}
                                    disabled={!isInEditMode && currentUserRosterTemplate && status !== 'draft'}
                                />
                            </Col>
                            <Col md={5}>
                                <label>{t('Shift')} {t('Cycle')}</label>
                                <div className="d-flex justify-content-center align-items-center fs14" style={{ width: '370px' }}>

                                    <div
                                        className='d-flex justify-content-between align-items-center'
                                        style={{
                                            width: '330px', border: '1px solid #cccccc', borderRadius: '10px', paddingTop: '6px', paddingBottom: '6px'
                                        }}
                                    >
                                        <span
                                            span
                                            className='p-1'
                                            style={{ cursor: isDateSameOrBeforeCycleStartDate || isExpired ? 'not-allowed' : 'pointer' }}
                                            title={isExpired ? t('This roster plan is expired due to department change for the user') : isDateSameOrBeforeCycleStartDate ? t('Cannot navigate to previous cycle as it goes beyond work rule start date') : ''}
                                            onClick={this.goPrev}
                                        >
                                            <b className="scheduleCaret rotate-90 m-1" ></b>
                                        </span>
                                        <span className="react-datepicker__input-container text-center">
                                            <span className="fw-600 ms-4">
                                                {`${t('From')} (${moment(cycleDetails?.startDate).format(dateTimeRules.short_date_format)}) ${t('To')} (${moment(cycleDetails?.endDate).format(dateTimeRules.short_date_format)})`}
                                            </span>
                                        </span>
                                        <span
                                            className='p-1 cursor-pointer'
                                            style={{ cursor: isExpired ? 'not-allowed' : 'pointer' }}
                                            title={isExpired ? t('This roster plan is expired due to department change for the user') : ''}
                                            onClick={this.goNext}
                                        >
                                            <b className="scheduleCaret rotate-270 m-1" ></b>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} className='d-flex justify-content-end gap-2'>
                        {canCreateAndEdit && <Button onClick={() => this.setState({ showCopyWeekModal: true })} disabled={!isInEditMode}>
                            <i className="fas fa-copy"></i>
                        </Button>}
                        {canCreateAndEdit && !isMember && status === 'published' && !isInEditMode &&
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t('This template is published. To edit it, you need to deactivate it first.')}
                                    </Tooltip>
                                }
                            >
                                <Button fill md onClick={this.handleEditTemplate}>
                                    {t('Deactivate and Edit')}
                                </Button>
                            </OverlayTrigger>
                        }
                        {canCreateAndEdit && ['approved', 'rejected', 'active'].includes(status) && !isInEditMode &&
                            <Button fill md onClick={() => this.handleEdit()} disabled={(isInLockInOfUnionApproval || isInLockInOfPublish)}>
                                {t('Edit')}
                            </Button>
                        }
                        {!isInEditMode && status === 'published' && !this.state.isNextCycleStatusActive &&
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t('Temporary disabled')}
                                    </Tooltip>
                                }
                            >
                                <Button onClick={this.handleCopyToNextCycle} disabled>
                                    {t('Copy')} {t('To')} {t('Next')} {t('Cycle')}
                                </Button>
                            </OverlayTrigger>
                        }
                    </Col>
                </Row >
                {
                    this.state.schedulerData && (
                        <div id='Roster-Scheduler' style={{ marginTop: '25px' }}>
                            <Scheduler
                                width={width}
                                schedulerData={this.state.schedulerData}
                                onSelectDate={onSelectDate}
                                eventItemClick={this.eventClicked}
                                showWeekHeaderAddIcon={true}
                                handleShowShiftCodeModal={this.handleShowShiftCodeModal}
                                singleResourceView={true}
                                userDetails={user}
                                weeklyHoursTotalsAndEmploymentPercent={weeklyHoursTotalsAndEmploymentPercent}
                                newEvent={this.newEvent}
                                eventItemTemplateResolver={this.customEventItemTemplate}
                                isRosterDisabled={!isInEditMode && currentUserRosterTemplate && currentUserRosterTemplate?.status !== 'draft'}
                                dateTimeRules={dateTimeRules}
                                t={t}
                                userWorkHoursRuleByDepartment={userWorkHoursRuleByDepartment}
                            />
                        </div>
                    )
                }
                {currentUserRosterTemplate?.department_impact_note &&
                    <div className="fw-600 mt-1 fs14 fst-italic">{t('Note')}: {currentUserRosterTemplate.department_impact_note}</div>
                }

                <WeeklyShiftCodeModal
                    showShiftCodeModal={showShiftCodeModal}
                    cycleDetails={cycleDetails}
                    selectedWeekData={selectedWeekData}
                    exceptions={this.state.exceptions}
                    cycleData={this.state.cycleData}
                    user={user}
                    isLoading={isLoading}
                    allowSaveShifts={this.state.allowSaveShifts}
                    isRosterPublished={status === 'published'}
                    userWorkHoursRuleByDepartment={userWorkHoursRuleByDepartment}
                    disableShiftsForDepartmentChanges={currentUserRosterTemplate?.Roster_Template?.rules?.department_updated_on ? currentUserRosterTemplate?.Roster_Template?.rules?.department_updated_on : null}
                    updateSelectedWeekData={this.updateSelectedWeekData}
                    handleHideShiftCodeModal={this.handleHideShiftCodeModal}
                    updateCycleData={this.updateCycleData}
                    generateEventsFromCycleData={this.generateEventsFromCycleData}
                    onAllowSaveShiftsChange={(value) => this.setState({ allowSaveShifts: value })}
                    approvedF5Dates={new Set(this.state.approvedF5Map ? [...this.state.approvedF5Map.values()] : [])}
                    f5Placements={this.state.f5Placements}
                />

                <Row className='mt-3'>
                    {Object.keys(exceptions).length ?
                        <Col md={8} >
                            <BrokenRuleCard
                                userWorkHoursRuleByDepartment={userWorkHoursRuleByDepartment}
                                exceptions={exceptions}
                                exceptionReasons={exceptionReasons}
                                saveExceptionReason={this.saveExceptionReason}
                                isRosterDisabled={!isInEditMode && currentUserRosterTemplate && currentUserRosterTemplate?.status !== 'draft'}
                            />
                        </Col>
                        : <></>}
                    <Col md={4} >
                        <Card style={{ borderRadius: '20px' }}>
                            <Card.Header className="fs15 w-100 m-0 text-white p-3 background-color-2550AC">{t('Total')} {t('For')} {t('Shift')} {t('Cycle')}</Card.Header>
                            <Card.Body>
                                <Row className="mb-2">
                                    <Col md={8} >
                                        <span className="fw-bold fs15">{t('Total')} {t('Work hours')}</span>
                                    </Col>
                                    <Col md={4}>
                                        <span className="fw-bold">{`${this.state.cycle_totals.total_work_hours} ${t('hr')}`}</span>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={8} >
                                        <span className="fw-bold fs15">{t('Average')} {t('Work')} {t('Hours')}</span>
                                    </Col>
                                    <Col md={4}>
                                        <span className="fw-bold">{`${this.state.cycle_totals.average_work_hours} ${t('hr')}`}</span>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={8} >
                                        <span className="fw-bold fs15">{t('Standby')} {t('Hours')}</span>
                                    </Col>
                                    <Col md={4}>
                                        <span className="fw-bold">{`${this.state.cycle_totals.total_standby_hours} ${t('hr')}`}</span>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={8}>
                                        <span className="fw-bold fs15">{t('Contracted')} % ({user.work_time_agreement}{t('hr')})</span>
                                    </Col>
                                    <Col md={4} >
                                        <span className="fw-bold">
                                            {`${this.state.cycle_totals.total_employment_percent_according_to_user_profile} ${('%')}`}
                                        </span>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={8}>
                                        <span className="fw-bold fs15">{t('Avg. Std. Employment')} % ({userWorkHoursRuleByDepartment.average_overtime_limit_per_week / 60}{t('hr')})</span>
                                    </Col>
                                    <Col md={4} >
                                        <span className="fw-bold">
                                            {`${this.state.cycle_totals.total_employment_percent_according_to_standard_control_panel_rule} ${('%')}`}
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {currentUserRosterTemplate?.status === 'published' && isInEditMode &&
                    <Row>
                        <i className='d-flex justify-content-end fw-600'>{t("The roster changes have been completed. Kindly ensure it is published under the user's schedule")}</i>
                    </Row>
                }

                <div className='d-flex justify-content-end gap-2 mt-2'>
                    <Button variant="outline-danger" onClick={() => this.getBack()}>
                        {t('Close')}
                    </Button>
                    {(!currentUserRosterTemplate || currentUserRosterTemplate?.status === 'draft') && <Button variant="outline-danger" onClick={() => this.handleSaveTemplate('draft')} disabled={!isInEditMode && currentUserRosterTemplate && currentUserRosterTemplate?.status !== 'draft' || (isInLockInOfUnionApproval || isInLockInOfPublish)}>
                        {t('Save as draft')}
                    </Button>}
                    {this.state.saveParticularUserTemplate ?
                        <Button fill dynamic_lg onClick={() => this.handleSaveTemplate('active')} disabled={(!isInEditMode && currentUserRosterTemplate && currentUserRosterTemplate?.status !== 'draft') || ((isInLockInOfUnionApproval || isInLockInOfPublish) && currentUserRosterTemplate && status !== 'published')}>
                            {t('Save')}
                        </Button>
                        :
                        <Button fill dynamic_lg onClick={() => this.handleCheckStatusAndSave(isMultiUserTemplate)} disabled={(!isInEditMode && currentUserRosterTemplate && currentUserRosterTemplate?.status !== 'draft') || ((isInLockInOfUnionApproval || isInLockInOfPublish) && !status && status !== 'published')}>
                            {currentUserRosterTemplate?.status === 'published' ? t('Publish') : `${t('Save')} ${t('Roster')}`}
                        </Button>
                    }
                </div>

                {this.state.showCopyWeekModal &&
                    <CopyWeeks
                        cycleDetails={cycleDetails}
                        closeModal={() => this.setState({ showCopyWeekModal: false })}
                        cycleData={{ [this.state.user.id]: removeEmptyObjects(this.state.cycleData) }}
                        users={[{ ...this.state.user, name: `${this.state.user.first_name} ${this.state.user.last_name}` }]}
                        isSingleCopy
                        updateCycleData={this.loadCopyWeekCycleData}
                    />
                }

                <Modal
                    size="md"
                    centered
                    show={this.state.showEditInputModal}
                    onHide={() => this.setState({ showEditInputModal: false })}
                >
                    <Modal.Header className="set_ModalHeader">
                        <Modal.Title className='w-100 text-center custom-modal-title'>
                            {t('Apply Changes')}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            onClick={() => this.setState({ showEditInputModal: false })}
                            alt='close-btn'
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t('How do you want to apply changes')}?</p>
                        <p>**{t('Applying Changes to only selected member, you need to updated the template name')}?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button fill md onClick={() => this.handleSingleSave()}>{t('Only')} {user.first_name + " " + user.last_name}</Button>
                        <Button fill md onClick={() => this.handleEntireTemplateSave()}>{t('All the member')}</Button>
                        <Button onClick={() => this.setState({ showEditInputModal: false })}>{t('Close')}</Button>
                    </Modal.Footer>
                </Modal>

                {showUrgentShiftModal &&
                    <Modal
                        size="xl"
                        backdrop="static"
                        show
                    >
                        <Modal.Header>
                            <Modal.Title>{t('Urgent Management')}</Modal.Title>
                            <img
                                src={CloseModalIcon}
                                className="cursor-pointer"
                                onClick={this.handleCloseUrgentShiftModal}
                                alt={'close-icon'}
                            />
                        </Modal.Header>
                        <Modal.Body>
                            <UrgentCallManagement
                                handleCloseUrgentShiftModal={this.handleCloseUrgentShiftModal}
                                urgentCallEditing={urgentCallEditing}
                                conflictMessage={conflictMessage}
                            />
                        </Modal.Body>
                    </Modal>
                }
            </div >
        );
    }
}

export default inject('userStore', 'commonStore', 'scheduleStore', 'clientStore', 'rosterStore')(withLocalization(applicationRouter(withDragDropContext(observer(CreateRosterTemplate)))));